import axios from 'axios';
import { getAuthHeader } from  '../global_helpers/authHeader.js';
import { getTPAID } from  '../global_helpers/sessionReturn.js';

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

const state = {
    loading: true,
    widgets: {
        YTDProspects: null,
        YTDSold: null,
        YTDClosePercent: null,
        YTDDeadProspects: null,
        YTDProposals: null,
        YTDAssets: null,
        YTDLOIPercent: null,
    },
    charts: {
        ProposalByProvider: [],
        ProposalByProviderMaxInArray: null,
        PercentOfLOI:[],
        PercentOfLOISumCount: null,
        PercentOfLOIMaxInArray: null
    }
};

const getters = {
    isLoading: state => state.loading,
    widgets: state => state.widgets,
    charts: state => state.charts,
};

const actions = {    
    async getDashboardDataForWidgets ({commit}){
        let authHeader = getAuthHeader();
        let tpa_id = getTPAID();
        let currentDate = new Date();        
        let beginDate = currentDate.getFullYear() + '-01-01';
        let ed = new Date().addDays(1)
        let endDate = formatDate(ed);
        const res = await axios.get('/dashboard/'+'?tpa_id='+tpa_id+'&beginDate='+beginDate+'&endDate='+endDate, authHeader);
        commit('setdata', res.data);
    },
};

const mutations = {
    setdata(state, data) {
        state.widgets.YTDProspects = data.YTDProspects;
        state.widgets.YTDSold = data.YTDSold;
        state.widgets.YTDClosePercent = data.YTDClosePercent;
        state.widgets.YTDDeadProspects = data.YTDDeadProspects;
        state.widgets.YTDProposals = data.YTDProposals;
        state.widgets.YTDAssets =  data.YTDAssets;
        state.widgets.YTDLOIPercent = data.YTDLOIPercent;

        state.charts.ProposalByProvider = data.ProposalByProvider;
        state.charts.ProposalByProviderMaxInArray = Math.max.apply(Math, data.ProposalByProvider.map(function(o) { return o.count; }));
        state.charts.PercentOfLOI = data.PercentOfLOI;
        var count = data.PercentOfLOI.reduce(function (accumulator, currentValue) {
            return parseInt(accumulator || 0) + parseInt(currentValue.count || 0);
        }, 0)
        state.charts.PercentOfLOISumCount = count;
        state.charts.PercentOfLOIMaxInArray = Math.max.apply(Math, data.PercentOfLOI.map(function(o) { return o.count; }));
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

function formatDate(date) {
    let d = new Date(date);
    let year = d.getUTCFullYear();
    let month = '' + (d.getUTCMonth() + 1);
    let day = '' + (d.getUTCDate());
    
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}